import d3 from './d3-custom';

export default class Tree {
  constructor(options) {
    this.duration = options.duration;
    this.rectangleProperties = options.rectangle;
    this.counter = 0;
    this.questionFlag = options.questionsEnabled;
    this.clickHandler = options.clickHandler;
    this.zoomHandler = options.zoomHandler;
    this.treemap = d3.tree()
      .nodeSize([this.rectangleProperties.recWidth + this.rectangleProperties.spaceBetweenRecX, 0]);
      // .separation(function(a,b){
      //   return a.parrent==b.parrent?1:1
      // });

    // Set very large size SVG
    let wrapper = d3.select('.content-item.active .pyramid__builder-tree__diagram');
    const svgWidth = 100000;
    if(wrapper.select('svg').empty()) {
      this.svgEl = wrapper.append('svg')
          .attr('class', 'pyramid')
          .attr('width', `${svgWidth}px`)
          .style('margin-left', '-50000px');
      this.svgEl.append('svg:defs');
    } else {
      return;
    }

    // Create inner group element and translate to center
    let svgCenterX = svgWidth / 2 + $(window).outerWidth() / 2 - this.rectangleProperties.recWidth / 2; // calculate centerX
    this.svg = this.svgEl.append('g')
      .attr('transform', 'translate(' + svgCenterX + ',' + 0 + ')'); // center group wrapper Xaxis

    // Change group translate on window resize
    window.addEventListener("resize", () => {
      svgCenterX = svgWidth / 2 + $(window).outerWidth() / 2 - this.rectangleProperties.recWidth / 2; // calculate centerX
      this.svg.attr('transform', 'translate(' + svgCenterX + ',' + 0 + ')');
    }, true);

    this.treeDepth = 0;

    // zoom
    this.zoom = {
      scale: options.zoom,
      d3: d3.zoom()
        // range of scale
        .scaleExtent([0.2, 2])
        // wheel sensivity
        .wheelDelta(() => {
          return -d3.event.deltaY * (d3.event.deltaMode ? 120 : 1) / 1000;
        })
        // d3 zoom event
        .on('zoom', () => {
          this.zoom.scale = d3.event.transform;
          this.zoomHandler(this.zoom.scale);
          d3.select('.tab-content').style('transform', 'translate(' + this.zoom.scale.x + 'px,' + this.zoom.scale.y + 'px) scale(' + this.zoom.scale.k + ')');
        })
        // filter to disable zoom events on '_no_drag' class
        .filter(() => { return !d3.event.path[0].closest('._no_drag') || d3.event.type == 'wheel' }),
      element: d3.select('.tabs__wrapper')
    }
    // disable zoom on dblclick
    this.zoom.element.call(this.zoom.d3)
      .on("dblclick.zoom", null);

    if (!options.mouseWheelZoom) {
      this.zoom.element.on("wheel.zoom", null);
    }
  }

  init(data) {
    // set zoom
    setTimeout(() => {
      this.zoom.element.transition().duration(1300)
        .call(this.zoom.d3.transform, d3.zoomIdentity.translate(this.zoom.scale.x, this.zoom.scale.y).scale(this.zoom.scale.k));
    }, 500);

    if (!this.svgEl || data === 'empty') return;

    this.root = d3.hierarchy(data[0] || data);
    this.root.x0 = 0;
    this.root.y0 = 0;
    this.selectedNode = this.root;
    // this.clickHandler(this.selectedNode);

    this.treeScheme = this.root;

    this.update(this.root);
  }

  zoomTo(scale) {
    this.zoomHandler(scale);
    this.zoom.d3.scaleTo(this.zoom.element, scale);
  }

  changeDeductive(selected = this.selectedNode) {
    selected.data.deductive = !selected.data.deductive;
    this.update(selected);
  }

  changeChildsNodeCount(selected = this.selectedNode, numberFromInput) {
    let numberOfChildNodes = selected.children ? selected.children.length : 0;
    let diffBetweenNodesCount = numberFromInput - numberOfChildNodes;
    if (Math.abs(numberFromInput > 5)) {
      return;
    }
    // if selected node have empty children Array
    if (!selected.children) {
      selected.children = [];
      selected.data.children = [];
    }

    //if add Nodes
    if (diffBetweenNodesCount > 0) {

      // create new Node model object
      let newNodeObj = {
        model: null,
        children: []
      };

      // creates new Node
      do {
        let newNode = d3.hierarchy(newNodeObj);
        newNode.depth = selected.depth + 1;
        newNode.height = selected.height + 1;
        newNode.parent = selected;
        selected.children.push(newNode);
        selected.data.children.push(newNode.data);
        diffBetweenNodesCount--;
      } while (diffBetweenNodesCount > 0);

    } else { // if remove Nodes
      selected.children.splice(diffBetweenNodesCount);
      selected.data.children.splice(diffBetweenNodesCount);
    }
    if (selected.children.length == 0) {
      selected.children = null;
      selected.data.children = null;
      this.update(selected);
    } else {
      this.update(selected);
    }
  }

  toggleQuestions(activeFlag) {
    let textareas = d3.selectAll('.pyramid__builder-wrapper .pyramid__node_wrp textarea');
    let questions = d3.selectAll('.pyramid__builder-wrapper .pyramid__node_wrp .pyramid__node_q');
    if (activeFlag) {
      this.questionFlag = true;
      textareas.transition().duration(this.duration)
        .style('height', '80px');

      questions.transition().duration(this.duration / 2)
        .style('height', '30px')
        .delay(this.duration / 2)
        .transition().duration(this.duration)
        .style('padding', '2px 4px 3px');
    } else {
      this.questionFlag = false;
      textareas.transition().duration(this.duration)
        .style('height', '105px');

      questions.transition().duration(this.duration / 2)
        .style('padding', '0px 4px 0px')
        .style('height', '0px');
    }
  }

  update(source) {

    // Create object that store tree scheme assigns the x and y position for the nodes
    this.treeScheme = this.treemap(this.root);

    // compute the new tree layout.
    let nodes = this.treeScheme.descendants().reverse(); // reversed for NODES element z-index (parents on top)
    let links = this.treeScheme.descendants().slice(1).reverse();  // reversed for LINKS element z-index (links under NODES)

    // recalculate svg height
    let treeDepth = d3.max(nodes, (d) => {
      return +d.depth;
    })

    let delay = treeDepth > this.treeDepth ? 0 : this.duration;
    setTimeout(() => {
      this.svgEl.attr('height', treeDepth * (this.rectangleProperties.spaceBetweenRecY) + this.rectangleProperties.recHeight + 1550);
    }, delay);
    this.treeDepth = treeDepth;

    // normalize for fixed-depth.
    nodes.forEach((d) => {
      d.y = d.depth * this.rectangleProperties.spaceBetweenRecY;
    });


    // ### LINKS
    // update the links...
    let link = this.svg.selectAll('line.pyramid__link')
      .data(links, (d) => {
        return d.id || (d.id = ++this.counter);
      });

    // enter any new links at the parent's previous position.
    let linkEnter = link.enter().insert("line", ":first-child")
      .attr('class', 'pyramid__link')
      .attr('x1', (d) => {
        return source.x0 + this.rectangleProperties.recWidth / 2;
      })
      .attr('y1', (d) => {
        if (d.parent.data.deductive) {
          return source.y0 + this.rectangleProperties.recHeight - 12;
        } else {
          return source.y0 + this.rectangleProperties.recHeight - 3;
        }
      })
      .attr('x2', (d) => {
        return source.x0 + this.rectangleProperties.recWidth / 2;
      })
      .attr('y2', (d) => {
        return source.y0 + this.rectangleProperties.recHeight;
      });


    let linkUpdate = linkEnter.merge(link);

    // transition back to the parent element position
    linkUpdate.transition().duration(this.duration)
      .attr('x1', (d) => {
        // check if parent is deductive (same logic used for next points)
        if (d.parent.data.deductive) {
          // get children object from parent from id
          let thisChild = d.parent.children.find(obj => obj.id === d.id);
          // get this Node index
          let i = d.parent.children.indexOf(thisChild) + 1;
          // check if this Node child not last
          if (i < d.parent.children.length) {
            return d.parent.children[i].x;
          } else { // if last child Node
            if (i <= 2) { // if child count <=2  centering parent x point
              return d.parent.x + this.rectangleProperties.recWidth / 2;
            } else {
              return d.parent.x + this.rectangleProperties.recWidth;
            }
          }
        } else {
          return d.parent.x + this.rectangleProperties.recWidth / 2;
        }
      })
      .attr('y1', (d) => {
        if (d.parent.data.deductive) {
          let thisChild = d.parent.children.find(obj => obj.id === d.id);
          let i = d.parent.children.indexOf(thisChild) + 1;
          if (i < d.parent.children.length) {
            return d.y + this.rectangleProperties.recHeight / 2;
          } else {
            return d.parent.y + this.rectangleProperties.recHeight;
          }
        } else {
          return d.parent.y + this.rectangleProperties.recHeight - 2;
        }
      })
      .attr('x2', (d) => {
        if (d.parent.data.deductive) {
          let thisChild = d.parent.children.find(obj => obj.id === d.id);
          let i = d.parent.children.indexOf(thisChild) + 1;
          if (i < d.parent.children.length) {
            return d.x;
          } else {
            return d.x + this.rectangleProperties.recWidth / 2;
          }
        } else {
          return d.x + this.rectangleProperties.recWidth / 2;
        }
      })
      .attr('y2', (d) => {
        if (d.parent.data.deductive) {
          let thisChild = d.parent.children.find(obj => obj.id === d.id);
          let i = d.parent.children.indexOf(thisChild) + 1;
          if (i < d.parent.children.length) {
            return d.y + this.rectangleProperties.recHeight / 2;
          } else {
            return d.y + 2;
          }
        } else {
          return d.y + 2;
        }
      })
      // add marker arrow to line
      .attr('marker-start', (d) => {
        // if root element
        let markerId = !d.parent.parent ? 0 : d.parent.id;

        if (d.parent.data.deductive) {
          if (this.svgEl.select('#arrow_' + markerId).empty()) {
            this.svgEl.select('defs').append('svg:marker')
              .attr('id', 'arrow_' + markerId)
              .attr('viewBox', '0 -5 10 10')
              .attr('refX', 9)
              .attr('opacity', 0)
              .attr('markerWidth', 6)
              .attr('markerHeight', 6)
              .attr('orient', 'auto-start-reverse')
              .append('svg:path')
              .attr('d', 'M0,-5L10,0L0,5')
              .attr('fill', '#fff');
          }
        }

        return 'url(#arrow_' + markerId + ')';
      })
      // deductive arrow transition
      .on('start', (d) => {
        // if root element
        let markerId = !d.parent.parent ? 0 : d.parent.id;

        if (d.parent.data.deductive) {
          d3.select('#arrow_' + markerId).transition().duration(this.duration)
            .attr('opacity', 1);
        } else {
          d3.select('#arrow_' + markerId).transition().duration(this.duration)
            .attr('opacity', 0);
        }
      });

    // remove any exiting links
    let linkExit = link.exit()
      .transition().duration(this.duration)
      .attr('x1', (d) => {
        if (d.parent.data.deductive && d.parent.children) {
          let thisChild = d.parent.children.find(obj => obj.id === d.id);
          let i = d.parent.children.indexOf(thisChild) + 1;

          if (i <= 2) { // if child count <=2  centering parent x point
            return d.parent.x + this.rectangleProperties.recWidth / 2 - 5;
          } else {
            return d.parent.x + this.rectangleProperties.recWidth - 5
          }
        } else {
          return source.x + this.rectangleProperties.recWidth / 2;
        }
      })
      .attr('y1', (d) => {
        return source.y + this.rectangleProperties.recHeight - 3;
      })
      .attr('x2', (d) => {
        return source.x + this.rectangleProperties.recWidth / 2;
      })
      .attr('y2', (d) => {
        return source.y;
      })
      .remove();


    // NODES
    // update the nodes
    let node = this.svg.selectAll('g.pyramid__node')
      .data(nodes, (d) => {
        return d.id || (d.id = ++this.counter);
      });

    // enter any new modes at the parent's previous position.
    let nodeEnter = node.enter().append('g')
      .attr('class', 'pyramid__node')
      .attr('pointer-events', 'none')
      .attr('transform', () => 'translate(' + source.x0 + ',' + source.y0 + ')')
      .on('click', (d) => {
        this.selectedNode = d;
        this.clickHandler(this.selectedNode);
      });

    // add rect for the nodes
    nodeEnter.append('rect')
      .attr('class', 'pyramid__node')
      .attr('width', this.rectangleProperties.recWidth)
      .attr('height', this.rectangleProperties.recHeight)
      .attr('rx', 8);

    // add html for the nodes
    nodeEnter.append('foreignObject')
      // Node btns events
      .on('click', (d) => {
        // plus
        if (d3.event.target.closest('.pyramid__node_btnsPlus')) {
          let currentChildrenCount = d.children ? d.children.length + 1 : 1;
          this.changeChildsNodeCount(d, currentChildrenCount);
        }
        // minus
        if (d3.event.target.closest('.pyramid__node_btnsMinus')) {
          let index = d.parent.children.map(x => {
            return x.id;
          }).indexOf(d.id);

          d.parent.children.splice(index, 1);
          d.parent.data.children.splice(index, 1);
          // if children array is empty change to null
          if (!d.parent.children.length) d.parent.children = null;

          this.update(d.parent);
        }

      })
      .attr('width', this.rectangleProperties.recWidth + 20)
      .attr('height', this.rectangleProperties.recHeight)
      .attr('xlmns', 'http://www.w3.org/1999/xhtml')
      .append('xhtml:body')
      .append('div')
      .attr('class', 'pyramid__node_wrp _no_drag')
      .html((d) => {
        // set model if null
        if (!d.data.model) {
          d.data.model = {
            textarea: '',
            question: ''
          }
        }
        // if Node has'nt parent element (if root Node)
        let minusBtnHtml = d.parent ? '<div class="pyramid__node_btnsMinus"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M24 11c0-0.6-0.4-1-1-1H1c-0.6 0-1 0.4-1 1v2c0 0.6 0.4 1 1 1h22c0.6 0 1-0.4 1-1V11z"/></svg></div>' : '';
        let plusBtnHtml = '<div class="pyramid__node_btnsPlus"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m23 10h-8.5c-0.3 0-0.5-0.2-0.5-0.5v-8.5c0-0.6-0.4-1-1-1h-2c-0.6 0-1 0.4-1 1v8.5c0 0.3-0.2 0.5-0.5 0.5h-8.5c-0.6 0-1 0.4-1 1v2c0 0.6 0.4 1 1 1h8.5c0.3 0 0.5 0.2 0.5 0.5v8.5c0 0.6 0.4 1 1 1h2c0.6 0 1-0.4 1-1v-8.5c0-0.3 0.2-0.5 0.5-0.5h8.5c0.6 0 1-0.4 1-1v-2c0-0.6-0.4-1-1-1z"/></svg></div>';

        // Render new item textarea and question whithout/whith styling
        let questionStyling;
        if (this.questionFlag) {
          questionStyling = '<textarea autocomplete="nope" name="textarea_' + d.id + '">' + d.data.model.textarea + '</textarea><div class="pyramid__node_q"><p>Q:</p><input autocomplete="nope" type="text" value="' + d.data.model.question + '" name="input_' + d.id + '"></div>';
        } else {
          questionStyling = '<textarea style="height: 105px;" autocomplete="nope" name="textarea_' + d.id + '">' + d.data.model.textarea + '</textarea><div class="pyramid__node_q" style="height: 0px; padding: 0px 4px;"><p>Q:</p><input autocomplete="nope" type="text" value="' + d.data.model.question + '" name="input_' + d.id + '"></div>';
        }

        // return html of foreightObject
        return questionStyling + '<div class="pyramid__node_btns">' + minusBtnHtml + plusBtnHtml + '</div>';
      })
      // textarea onchange event
      .select('textarea').on('change', (d) => {
        d.data.model.textarea = d3.event.target.value;
        this.clickHandler(d);
      });

    // show Node btn on hover
    d3.selectAll('.pyramid__node')
      .on('mouseenter', function (d) {
        d3.select(this).select('.pyramid__node_btns')
          .style('opacity', 1);
      })
      .on('mouseleave', function (d) {
        d3.select(this).select('.pyramid__node_btns')
          .style('opacity', 0);
      })
      // input onchange event
      .select('input').on('change', (d) => {
        d.data.model.question = d3.event.target.value;
        this.clickHandler(d);
      });

    // update
    let nodeUpdate = nodeEnter.merge(node);

    // transition to the proper position for the node
    nodeUpdate.attr('pointer-events', 'all')
      .transition().duration(this.duration)
      .attr('transform', (d) => {
        return 'translate(' + d.x + ',' + d.y + ')';
      });

    // update the node attributes and style
    nodeUpdate.select('g.pyramid__node')
      .attr('width', this.rectangleProperties.recWidth)
      .attr('height', this.rectangleProperties.recHeight)
      .attr('rx', 8);

    // if Node has > 5 childrens hide plus btn
    nodeUpdate.select('.pyramid__node_btnsPlus')
      .style('display', (d) => {
        if (d.children) {
          if (d.children.length > 4) {
            return 'none';
          } else {
            return 'block';
          }
        } else {
          return 'block';
        }
      });

    // remove any exiting nodes
    let nodeExit = node.exit()
      .attr('pointer-events', 'none')
      .transition().duration(this.duration)
      .attr('transform', (d) => {
        return 'translate(' + source.x + ',' + source.y + ')';
      })
      .remove();

    // store the old positions for transition.
    nodes.forEach((d) => {
      d.x0 = d.x;
      d.y0 = d.y;
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/components/pyramid-builder/pyramid-renderer.view.js